import {
  SmsUserFactorProfile,
  CallUserFactorProfile,
} from "@okta/okta-sdk-nodejs";
import { QrCodeData } from "global-components/mfa/types/qrCodeData";

import { FactorTypeEnum, Provider } from "types/factor/factor";

export enum StatusEnum {
  Success = "SUCCESS",
  MfaEnroll = "MFA_ENROLL",
  MfaEnrollActivate = "MFA_ENROLL_ACTIVATE",
}

export enum FactorStatus {
  Active = "ACTIVE",
  NotSetup = "NOT_SETUP",
}

export type TransactionFactor = {
  enrollment: string;
  factorType: FactorTypeEnum;
  provider: Provider;
  status: FactorStatus;
  vendorName: string;
  phones?: Array<{
    profile: SmsUserFactorProfile | CallUserFactorProfile;
  }>;
};

export type AuthTransaction = {
  status: StatusEnum;
  sessionToken?: string;
  data: {
    status: StatusEnum;
    stateToken: string;
    _links?: { skip?: { href: string } };
    _embedded?: {
      factor: {
        _embedded: {
          activation: QrCodeData;
        };
      };
    };
  };
  factor: {
    factorType: FactorTypeEnum;
    provider: Provider;
  };
  factors?: TransactionFactor[];
  user: {
    id: string;
    profile: {
      login: string;
    };
  };
};
